module.exports = __webpack_public_path__ + "../resources/img/bg_storage1_03.1cf45c22.png";